import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ToastProvider } from '@core';
import { CasesApi } from '../../../infrastructure/api/cases.api';
import { SubmitForApprovalCommand } from './submit-for-approval.command';
import { SubmitForApprovalResult } from './submit-for-approval.result';

@Injectable({ providedIn: 'root' })
export class SubmitForApprovalUseCase {
  private readonly _api = inject(CasesApi);
  private readonly _toast = inject(ToastProvider);

  public execute(command: SubmitForApprovalCommand): Observable<SubmitForApprovalResult> {
    return this._api.submitForApproval(command.caseId).pipe(
      tap(() => {
        this._toast.success(
          'Submitted for approval',
          'The case has been submitted for approval.'
        );
      }),
      map(() => ({ success: true })),
      catchError((error) => {
        this._toast.error(
          'Failed to submit for approval',
          'Please try again or contact support if the issue persists.'
        );
        return throwError(() => error);
      })
    );
  }
}
